export default __webpack_public_path__ + "static/media/poster.8f3c748e.jpg";